import { Rank, RankMapping, User } from "./types";
import { GROUP_ADMINS, GROUP_SIGNERS, GROUP_SUPER_ADMINS } from "../../consts";

export const ranks = new Map<Rank, RankMapping>([
  [Rank.SuperAdmin, { group: GROUP_SUPER_ADMINS, name: "Super Administrator" }],
  [Rank.Admin, { group: GROUP_ADMINS, name: "Administrator" }],
  [Rank.Signer, { group: GROUP_SIGNERS, name: "Signing User" }],
  [Rank.User, { name: "User" }],
]);

export const getRank = ({ groups }: { groups: string[] }): Rank => {
  for (const [rank, { group }] of ranks) {
    if (group && groups.includes(group)) {
      return rank;
    }
  }

  return Rank.User;
};

const isRank = (rank: Rank): rank is Rank =>
  Number.isInteger(rank) && !!Rank[rank];

export const getRanks = (): Rank[] => Object.values(Rank).filter(isRank);

export const getRankName = (rank: Rank): string => ranks.get(rank)?.name;

export const getUserRankName = ({ rank }: User): string => ranks.get(rank)?.name;

export const getRankGroup = (rank: Rank): string => ranks.get(rank)?.group;

export const rankGroups: string[] = [...ranks.values()]
  .map(({ group }) => group)
  .filter(Boolean);

export const isAtLeast =
  (got: Rank) =>
  (required: Rank): boolean =>
    got >= required;

export const isExactly =
  (got: Rank) =>
  (required: Rank): boolean =>
    got === required;
